import { render, staticRenderFns } from "./classfityModules.vue?vue&type=template&id=12e8278f&"
import script from "./classfityModules.vue?vue&type=script&lang=js&"
export * from "./classfityModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports